import * as CallCentreStatusSelectors from './call-centre-status.selectors';
import * as ComplianceSummarySelectors from './compliance-summary.selectors';
import * as NmcNmbiStatusSelectors from './nmc-nmbi-status.selectors';
import * as PayRatesSelectors from './pay-rates.selectors';
import * as StaffDetailsSelectors from './staff-details.selectors';
import * as WelcomePackSelectors from './welcome-pack.selectors';
import * as FirstShiftAppointmentsSelectors from './first-shift-appointment-status.selectors';
import * as AdvancePreferencesSelectors from './advance-preferences.selectors';

export const SharedSelectors = {
  ...CallCentreStatusSelectors,
  ...ComplianceSummarySelectors,
  ...NmcNmbiStatusSelectors,
  ...PayRatesSelectors,
  ...StaffDetailsSelectors,
  ...WelcomePackSelectors,
  ...FirstShiftAppointmentsSelectors,
  ...AdvancePreferencesSelectors,
};
